import { useEffect, useState } from 'react'
import { ThemeContext } from '../context'

import { ReactNode } from 'react'

interface ThemeProviderProps {
    children: ReactNode
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
    // Default theme is 'light'. It will be overwritten by localStorage if available.
    const [theme, setTheme] = useState<'light' | 'dark'>(
        (localStorage.getItem('theme') as 'light' | 'dark') || 'light'
    )

    // Get theme from localStorage on component mount
    useEffect(() => {
        const savedTheme = localStorage.getItem('theme') as
            | 'light'
            | 'dark'
            | null
        if (savedTheme) {
            setTheme(savedTheme)
        }
    }, [])

    // Whenever the theme changes, update the `data-theme` attribute and save to localStorage
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme)
        localStorage.setItem('theme', theme) // Persist theme choice in localStorage
    }, [theme])

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'))
    }
    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    )
}
